import BackButton from '@portal/features/navigation/BackButton'
import { Header } from '@portal/features/navigation/Header'
import NewSubmission from '@portal/features/submissions/NewSubmission'
import { GroupTitle } from '@portal/features/titles'
import { createFileRoute, useParams } from '@tanstack/react-router'

const RouteComponent = () => {
  const { surveyId } = useParams({ strict: false })

  return (
    <>
      <Header.Left>
        <BackButton to={`/surveys/${surveyId}/submissions`} />
      </Header.Left>
      <Header.Center>
        <GroupTitle />
      </Header.Center>
      <NewSubmission />
    </>
  )
}

export const Route = createFileRoute(
  '/_app/surveys/$surveyId/topics_/$topicId/submission'
)({
  component: RouteComponent,
})
